import type { BoxProps } from '@chakra-ui/react';
import { HStack, Text } from '@chakra-ui/react';
import { VerifiedTick } from '@time-line/components/icons';

interface VerifiedBuyerBadgeProps extends BoxProps {
  size?: string;
}

export function VerifiedBuyerBadge({
  size = 'detail',
  ...props
}: VerifiedBuyerBadgeProps) {
  return (
    <HStack gap="5xs" {...props}>
      <Text as="span" display="block" color="blackAlpha.700" size={size}>
        Verified buyer
      </Text>
      <VerifiedTick boxSize="2xs" color="blackAlpha.500" />
    </HStack>
  );
}
